module.exports = __webpack_public_path__ + "static/media/CompositeTouch.f5f8ba47.png";